"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NarrowCertificate = void 0;

var tslib_1 = require("tslib");

var Kebab_1 = require("@skbkontur/react-ui/components/Kebab");

var Certificate_1 = tslib_1.__importDefault(require("@skbkontur/react-icons/Certificate"));

var react_1 = tslib_1.__importDefault(require("react"));

var Certificate_module_css_1 = tslib_1.__importDefault(require("./Certificate.module.css"));

var classnames_1 = tslib_1.__importDefault(require("classnames"));

var ContextMenu_1 = require("./ContextMenu");

var utils_1 = require("./utils");

var CabucStatusInfo_1 = require("./CabucStatusInfo");

var shared_1 = require("../../shared");

var constants_1 = require("../../utils/constants");

var Parameters_1 = require("../Control/Parameters");

var configuration_1 = require("../../contexts/configuration");

var StatusesWithoutView = [shared_1.CabucStatusCode.DoNotNeedUpdate, shared_1.CabucStatusCode.Installed, shared_1.CabucStatusCode.HeraclesDoNotNeedUpdate, shared_1.CabucStatusCode.HeraclesInstalled];

var NarrowCertificate =
/** @class */
function (_super) {
  tslib_1.__extends(NarrowCertificate, _super);

  function NarrowCertificate() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.wrapDivRef = null;

    _this.onKebabOpen = function () {
      _this.context.trackEvent('kebabOpen');
    };

    _this.highlightWrap = function (fieldName, fieldValue) {
      var item = _this.props.item;
      return utils_1.highlight(fieldName, fieldValue, item, Certificate_module_css_1.default.highlight);
    };

    _this.onClick = function () {
      var _a = _this.props,
          onClick = _a.onClick,
          item = _a.item;

      if (onClick) {
        onClick(item.certificate, item.storeInfo, item);
      }
    };

    _this.onDoubleClick = function () {
      var _a = _this.props,
          onDoubleClick = _a.onDoubleClick,
          item = _a.item;

      if (onDoubleClick) {
        onDoubleClick(item.certificate, item.storeInfo, item);
      }
    };

    _this.stopClickEvent = function (e) {
      e.stopPropagation();
    };

    _this.skipEnter = function (e) {
      if (e.keyCode === constants_1.KEY_CODES.ENTER) {
        e.stopPropagation();
      }
    };

    _this.getValidToView = function () {
      var item = _this.props.item;
      var CAParams = _this.context.CAParams;

      if (item.statusInfo && !StatusesWithoutView.includes(item.statusInfo.status)) {
        return react_1.default.createElement(CabucStatusInfo_1.CabucStatusInfo, {
          item: item,
          CAParams: CAParams
        });
      }

      if (item.staticUpdateInfo) {
        return react_1.default.createElement(CabucStatusInfo_1.StaticUpdateInfo, {
          item: item
        });
      }

      if (item.state !== "Active"
      /* Active */
      ) {
          return react_1.default.createElement("div", {
            className: classnames_1.default(Certificate_module_css_1.default.red, Certificate_module_css_1.default.validToInfo)
          }, "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 ", _this.context.certificateProcessor.getValidToMessage(item));
        }

      if (item.hasDublicate) {
        return react_1.default.createElement("div", {
          className: Certificate_module_css_1.default.validToInfo
        }, _this.context.certificateProcessor.getValidToMessage(item, {
          capital: true,
          possessive: false
        }));
      }

      return react_1.default.createElement("noscript", null);
    };

    return _this;
  }

  NarrowCertificate.prototype.render = function () {
    var _a, _b, _c;

    var _this = this;

    var _d = this.context,
        showInnKppPrefix = _d.showInnKppPrefix,
        view = _d.view;
    var _e = this.props,
        item = _e.item,
        first = _e.first,
        last = _e.last,
        selected = _e.selected;
    var certificate = item.certificate;
    var kebabClassName = classnames_1.default((_a = {}, _a[Certificate_module_css_1.default.kebab] = true, _a[Certificate_module_css_1.default.modal] = view === Parameters_1.CertificatesListView.Modal, _a));
    var qualifiedIconClassName = classnames_1.default((_b = {}, _b[Certificate_module_css_1.default.qualifiedIcon] = true, _b[Certificate_module_css_1.default.modal] = view === Parameters_1.CertificatesListView.Modal, _b));
    var qualifiedIcon = certificate.isQualified() ? react_1.default.createElement("span", {
      className: qualifiedIconClassName
    }, react_1.default.createElement(Certificate_1.default, null)) : '';
    var certTypeIcon = utils_1.getCertTypeIcon(certificate);
    var kebab = react_1.default.createElement("div", {
      className: kebabClassName,
      onClick: this.stopClickEvent,
      onKeyDown: this.skipEnter
    }, react_1.default.createElement(Kebab_1.Kebab, {
      size: "large",
      onOpen: this.onKebabOpen
    }, react_1.default.createElement(ContextMenu_1.ContextMenu, {
      item: item
    })));
    var certClassName = classnames_1.default((_c = {}, _c[Certificate_module_css_1.default.certificate] = true, _c[Certificate_module_css_1.default.modal] = view === Parameters_1.CertificatesListView.Modal, _c[Certificate_module_css_1.default.selected] = selected, _c[Certificate_module_css_1.default.first] = first, _c[Certificate_module_css_1.default.last] = last, _c));
    var inn = this.highlightWrap('inn', certificate.inn());
    var kpp = this.highlightWrap('kpp', certificate.kpp());
    return react_1.default.createElement("div", {
      className: certClassName,
      onClick: this.onClick,
      onDoubleClick: this.onDoubleClick,
      ref: function ref(_ref) {
        return _this.wrapDivRef = _ref;
      }
    }, qualifiedIcon, kebab, react_1.default.createElement("span", {
      className: Certificate_module_css_1.default.organizationName,
      dangerouslySetInnerHTML: {
        __html: this.highlightWrap('organizationName', certificate.organizationName())
      }
    }), certTypeIcon, react_1.default.createElement("div", {
      className: Certificate_module_css_1.default.innKpp,
      dangerouslySetInnerHTML: {
        __html: utils_1.innKppString(inn, kpp, showInnKppPrefix)
      }
    }), react_1.default.createElement("div", {
      className: Certificate_module_css_1.default.owner,
      dangerouslySetInnerHTML: {
        __html: this.highlightWrap('owner', certificate.owner())
      }
    }), react_1.default.createElement("div", {
      "data-tid": "statusValidTo_" + certificate.thumbprint()
    }, this.getValidToView()));
  };

  NarrowCertificate.contextType = configuration_1.configurationContext;
  return NarrowCertificate;
}(react_1.default.Component);

exports.NarrowCertificate = NarrowCertificate;